import { MEDICAL_LICENSE_ROUTE_NAME } from '~/features/routeNames';
import { deleteData, getData, patchData, postData } from '../../../utils/service';
import {
  DeleteMedicalLicenseEvent,
  Events,
  PatchMedicalLicenseEvent,
  SubmitMedicalLicenseEvent,
} from './events';
import { MedicalLicenseContext, MedicalLicenseResponse } from './types';
import { formDataToMedicalLicense, medLicenseFormProvider, medLicensesFormProvider } from './utils';

interface InputArgs {
  input: {
    context: MedicalLicenseContext;
    event: Events;
  };
}
export const MEDICAL_LICENSES_ROUTES = {
  get: '/medical-licenses',
  post: '/medical-licenses',
  patch: '/medical-licenses/{id}',
  delete: '/medical-licenses/{id}',
};
export const MEDICAL_LICENSE_TYPES_ROUTE = {
  get: '/medical-license-type',
};

export const API_CALLS = {
  get: async (props: InputArgs): Promise<MedicalLicenseResponse[]> => {
    const { filter } = props.input.context;
    return await getData(MEDICAL_LICENSE_ROUTE_NAME, {
      filter: filter as unknown as { [key: string]: string },
      transformResponse: medLicensesFormProvider,
    });
  },
  create: async (props: InputArgs): Promise<MedicalLicenseResponse> => {
    const event = props.input.event as SubmitMedicalLicenseEvent;
    return await postData(MEDICAL_LICENSE_ROUTE_NAME, {
      data: event.values,
      transformRequest: formDataToMedicalLicense,
      transformResponse: medLicenseFormProvider,
    });
  },
  delete: async (props: InputArgs) => {
    const event = props.input.event as DeleteMedicalLicenseEvent;
    return await deleteData(MEDICAL_LICENSE_ROUTE_NAME, {
      pathParams: { id: event.payload.id.toString() },
    });
  },
  patch: async (props: InputArgs): Promise<MedicalLicenseResponse> => {
    const event = props.input.event as PatchMedicalLicenseEvent;
    return await patchData(MEDICAL_LICENSE_ROUTE_NAME, {
      pathParams: { id: event.values.id?.toString() || '' },
      data: event.values,
      transformRequest: formDataToMedicalLicense,
      transformResponse: medLicenseFormProvider,
    });
  },
};

export const getMedicalTypes = async () => await getData('medicalLicenseTypes');
